import React, { useContext } from 'react';
import {
  ClockCircleOutlined,
  CloseCircleOutlined,
  TeamOutlined,
} from '@ant-design/icons';

import RemoteAccessTotalsV2Context from '@totem/components/services/remoteAccess/v2/totals/RemoteAccessTotalsV2Context';
import IBStatistic, {
  statisticsStyles,
} from '@totem/components/ui_components/widgets/statistic/IBStatistic';

const styles = {
  table: {
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  cell: {
    padding: '16px',
    width: '25%',
  },
};

const RemoteAccessTotalsV2 = () => {
  const { totals } = useContext(RemoteAccessTotalsV2Context);

  const activeAccounts = totals?.active ?? 0;
  const staleAccounts = totals?.stale ?? 0;
  const neverLoggedInAccounts = totals?.neverLoggedIn ?? 0;
  const totalAccounts = totals?.total ?? 0;

  return (
    <table width="100%" style={styles.table}>
      <tbody>
        <tr>
          <td style={styles.cell}>
            <IBStatistic
              title="Total Accounts"
              subTitle="Across all roles you have access to"
              value={totalAccounts}
              precision={0}
              icon={<TeamOutlined />}
              style={statisticsStyles.info}
            />
          </td>
          <td style={styles.cell}>
            <IBStatistic
              title="Active Accounts"
              value={activeAccounts}
              precision={0}
              icon={<TeamOutlined />}
              style={statisticsStyles.ok}
            />
          </td>
          <td style={styles.cell}>
            <IBStatistic
              title="Stale Accounts"
              value={staleAccounts}
              precision={0}
              icon={<ClockCircleOutlined />}
              style={statisticsStyles.warning}
            />
          </td>
          <td style={styles.cell}>
            <IBStatistic
              title="Never Logged In"
              value={neverLoggedInAccounts}
              precision={0}
              icon={<CloseCircleOutlined />}
              style={statisticsStyles.critical}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default RemoteAccessTotalsV2;
